export default {
	InvoiceList: {
		Attached: 'File',
		File: 'Attachments',
		InvoiceNo: 'Invoice No. ',
		InvoiceDate: 'Invoice date',
		MCCQT: 'Tax Authority code',
		SignedDate: 'Signing date',
		TaxAuthorityCreatedDate: 'Submit to taxaxion date',
		IssueDate: 'Code issuance date',
		SupplierCode: 'Unit code',
		SellerName: 'Seller Name',
		SellerAddress: 'Seller Address',
		SellerTaxCode: 'Seller Tax Code',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		TotalHasDiscount: 'Total amount excluded VAT',
		TotalHasDiscountCC: 'Converted amount before tax',
		TaxReduction: 'Tax reduction',
		TotalVATAmount: 'Total VAT amount',
		TotalVATAmountCC: 'Total VAT amount exchange',
		TotalFeesAmountXML: 'Total fee amount',
		AmountOtherReduction: 'Total other reduction',
		TotalAmount: 'Total amount',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		TotalAmountExchange: 'Total amount exchange',
		Status: 'Checking result',
		IsRelativeInvoice: 'Related invoices',
		CheckDate: 'Last check date',
		CostType: 'Cost type',
		IsSendEmail: 'Email sending status',
		StatusInvoice: 'Invoice status',
		WarningPaymentDueDate: 'Payment due reminder date',
		PaymentDueDate: 'Payment due date',
		AmountPayment: 'Payment status',
		PaymentNumber: 'Payment number',
		TotalAmountNotPayment: 'Total amount not payment',
		CheckedVatStatus: 'Check the tax rate',
		CompanyName: 'Company name',
		CompanyTax: 'Company tax code',
		BranchName: 'Branch',
		BranchTax: 'Branch tax code',
		BuyerName: 'Buyer name',
		'InfoND123.BuyerFullName': 'Buyer',
		BuyerAddress: 'Buyer address',
		DepartmentName: 'Department',
		BuyerInvRevEmail: 'Invoice receipt email',
		Noted: 'Note',
		RefNo: 'Ref No.',
		AccountingDate: 'Accounting date',
		Accountant: 'Accountant',
		CreatedDate: 'System entry date',
		CostNorms: 'Cost norms',
		BeyondTheNorm: 'Beyond the norm',
		NonBeyondTheNorm: 'Non beyond the norm',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice XML',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		NotificationWrong: 'Notification wrong',
		LicensePlate: 'License plate',
		TypeInvoiceReceive: 'Invoice resources'
	},
	OutInvoiceList: {
		InvoiceNo: 'Invoice No. ',
		InvoiceDate: 'Invoice date',
		TaxAuthorityCreatedDate: 'Submit to taxaxion date',
		MCCQT: 'Tax Authority code',
		BuyerName: 'Buyer name',
		BuyerCode: 'Customer code',
		BuyerTaxCode: 'Buyer tax code',
		BuyerAddress: 'Buyer address',
		BuyerFullName: 'Buyer full name',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		TotalAmount: 'Total amount',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		TotalHasDiscount: 'Amount before VAT',
		TotalHasDiscountCC: 'Amount before VAT (converted)',
		TotalVATAmount: 'Total VAT amount',
		TotalVATAmountExchange: 'Total VAT amount (converted)',
		TotalAmountExchange: 'Total amount exchange',
		StatusInvoice: 'Invoice status',
		UploadFile: 'Invoice file'
	},
	SupplierList: {
		SupplierCode: 'Unit code',
		TaxCode: 'Tax code/Identification number',
		Name: 'Supplier/Customer name',
		Address: 'Address',
		BusinessAmount: 'Business',
		Owner: 'Owner',
		CompanyName: 'Company name',
		BranchName: 'Branch',
		DepartmentName: 'Department',
		//TotalInvoice: 'Input invoice',
		//TotalOutInvoice: 'Output invoice',
		PaymentDueDateNumber: 'Payment due date',
		NumberAccount: 'Account number',
		NameAccount: 'Account name',
		NameBank: 'Bank name',
		Agency: 'Branch',
		NameContact: 'Contact name',
		Email: 'Email',
		PhoneNumber: 'Phone number',
		Position: 'Position',
		DateCheck: 'Checking date',
		ActiveStatus: 'Active status',
		RiskStatus: 'Invoice risk',
		HistoryActiveStatus: 'Activity status history'
	},

	ReportInvoiceRiskBySupplier: {
		SellerName: 'Seller Name',
		BuyerTaxCode: 'Buyer Tax Code',
		BuyerName: 'Buyer Name',
		SellerTaxCode: 'Seller Tax Code',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signing date',
		InvoiceNo: 'Invoice No.',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		TotalAmountWithoutVat: 'Total amount excluded VAT',
		TotalVATAmount: 'Total VAT amount',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		StatusInvoice: 'Invoice status',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		'InfoND123.BuyerFullName': 'Buyer Full Name',
		PaymentDueDate: 'Payment due date',
		TotalAmountNotPayment: 'Total amount not payment',
		Status: 'Checking result',
		Noted: 'Note',
		BranchName: 'Branch',
		BranchTax: 'Branch tax code',
		DepartmentName: 'Department'
	},
	ReportInvoiceBySupplierActiveList: {
		StickInfo: 'Label',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signing date',
		InvoiceNo: 'Invoice No.',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		SellerName: 'Supplier',
		SellerTaxCode: 'Tax code',
		SellerAddress: 'Supplier address',
		ActiveStatus: 'Active status',
		TotalHasDiscount: 'Sales without tax',
		TotalVATAmount: 'Total VAT amount',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		Status: 'Checking result',
		StatusInvoice: 'Invoice status',
		NotificationWrong: 'Notification wrong',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		'InfoND123.BuyerFullName': 'Buyer',
		Noted: 'Note',
		BranchName: 'Branch',
		BranchTax: 'Branch tax code',
		DepartmentName: 'Department'
	},
	ReportInvoiceBySupplierActiveByInvoiceDateList: {
		StickInfo: 'Label',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signing date',
		InvoiceNo: 'Invoice No.',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		SellerName: 'Supplier',
		SellerTaxCode: 'Tax code',
		SellerAddress: 'Supplier address',
		ActiveStatus: 'Active status',
		TotalHasDiscount: 'Sales without tax',
		TotalVATAmount: 'Total VAT amount',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		Status: 'Checking result',
		StatusInvoice: 'Invoice status',
		NotificationWrong: 'Notification wrong',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		'InfoND123.BuyerFullName': 'Buyer',
		Noted: 'Note',
		BranchName: 'Branch',
		BranchTax: 'Branch tax code',
		DepartmentName: 'Department'
	},
	CustomsDeclarationList: {
		DeclarationNo: 'Customs Declaration No.',
		DeclarationDate: 'Customs Declaration Date',
		CreatedDate: 'System entry date',
		InvoiceNo: 'Invoice No.',
		ExporterName: 'Exporter',
		BuyerTaxCode: 'Tax code',
		BuyerAddress: 'Address',
		TotalDeclarationAmount: 'Total invoice amount',
		TotalDeclarationAmountExchange: 'Total converted invoice  amount',
		TotalPreCustomsFee: 'Total pre-customs fee',
		TotalPreCustomsFeeExchange: 'Total converted pre-customs fee',
		TotalTaxValue: 'Total taxable amount',
		TotalTaxAmount: 'Total tax amount',
		TotalPaymentAmountExchange: 'Total converted payment amount',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange Rate',
		CompanyName: 'Company Name',
		CompanyTax: 'Company Tax Code',
		BranchName: 'Branch Name',
		BranchTax: 'Branch Tax Code',
		DepartmentName: 'Department'
	},

	ReportInvoiceRelated: {
		SupplierName: 'Supplier Name',
		TaxCode: 'Tax Code',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signing date',
		InvoiceNo: 'Invoice No.',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		CheckingResult: 'Checking result',
		TotalHasDiscount: 'Sales without tax',
		TotalVATAmount: 'Total VAT amount',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		StatusInvoice: 'Invoice status',
		SearchCode: 'Search code',
		LinkSearch: 'Search link',
		RelatedInvoiceDate: 'Invoice date',
		RelatedInvoiceSignedDate: 'Signing date',
		RelatedInvoiceNo: 'Invoice No.',
		RelatedInvoiceTemplateNo: 'Form No.',
		RelatedInvoiceSeries: 'Serial',
		RelatedInvoiceCheckingResult: 'Checking result',
		RelatedInvoiceTotalHasDiscount: 'Sales without tax',
		RelatedInvoiceTotalVATAmount: 'Total VAT amount',
		RelatedInvoiceTotalAmount: 'Total amount',
		RelatedInvoiceTotalAmountExchange: 'Total amount exchange',
		RelatedInvoiceStatusInvoice: 'Invoice status',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		IncorrectInvoice: 'Incorrect invoice',
		TransferInvoice: 'Replacement invoice, adjustment'
	},
	ReportinvoiceStick: {
		StickOneName: 'Sticker 1',
		StickTwoName: 'Sticker 2',
		StickThreeName: 'Sticker 3',
		InvoiceCount: 'Number of invoices',
		UntaxedRevenue: 'Untaxed revenue',
		TotalConversionAmount: 'Total amount exchange',
		TotalAmount: 'Total amount',
		TotalAmountTax: 'Total VAT amount'
	},
	InvoiceListThirdParty: {
		Attached: 'File',
		File: 'Attachments',
		InvoiceNo: 'Invoice No. ',
		InvoiceDate: 'Invoice date',
		MCCQT: 'Tax Authority code',
		SignedDate: 'Signing date',
		TaxAuthorityCreatedDate: 'Submit to taxaxion date',
		IssueDate: 'Code issuance date',
		SupplierCode: 'Unit code',
		SellerName: 'Seller Name',
		SellerAddress: 'Seller Address',
		SellerTaxCode: 'Seller Tax Code',
		TemplateNo: 'Form No.',
		Series: 'Serial',
		TotalHasDiscount: 'Total amount excluded VAT',
		TotalHasDiscountCC: 'Converted amount before tax',
		TaxReduction: 'Tax reduction',
		TotalVATAmount: 'Total VAT amount',
		TotalVATAmountCC: 'Total VAT amount exchange',
		TotalFeesAmountXML: 'Total fee amount',
		AmountOtherReduction: 'Total other reduction',
		TotalAmount: 'Total amount',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		TotalAmountExchange: 'Total amount exchange',
		Status: 'Checking result',
		IsRelativeInvoice: 'Related invoices',
		CheckDate: 'Last check date',
		CostType: 'Cost type',
		IsSendEmail: 'Email sending status',
		StatusInvoice: 'Invoice status',
		WarningPaymentDueDate: 'Payment due reminder date',
		PaymentDueDate: 'Payment due date',
		AmountPayment: 'Payment status',
		PaymentNumber: 'Payment number',
		TotalAmountNotPayment: 'Total amount not payment',
		CheckedVatStatus: 'Check the tax rate',
		CompanyName: 'Company name',
		CompanyTax: 'Company tax code',
		BranchName: 'Branch',
		BranchTax: 'Branch tax code',
		BuyerName: 'Buyer name',
		'InfoND123.BuyerFullName': 'Buyer',
		BuyerAddress: 'Buyer address',
		DepartmentName: 'Department',
		BuyerInvRevEmail: 'Invoice receipt email',
		Noted: 'Note',
		RefNo: 'Ref No.',
		AccountingDate: 'Accounting date',
		Accountant: 'Accountant',
		CreatedDate: 'System entry date',
		CostNorms: 'Cost norms',
		BeyondTheNorm: 'Beyond the norm',
		NonBeyondTheNorm: 'Non beyond the norm',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice XML',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		NotificationWrong: 'Notification wrong',
		LicensePlate: 'License plate',
		TypeInvoiceReceive: 'Invoice resources'
	}
};
